import Logo from 'images/plantao-logo.svg';

export default function Index() {
  const logoContent = `
      <img
        src='${Logo}'
        alt="Time Link"
        height="52"
        width="180"
        style="height: 52px; width: auto; max-width: 200px; display: block;"
      />`;
  return logoContent;
}
